import React, { useEffect, useRef, useState } from 'react';

const AD_CLIENT = 'ca-pub-7653518886236897';

const AdBanner = ({ adSlot = '', format = 'auto', className = '' }) => {
  const adRef = useRef(null);
  const pushed = useRef(false);
  const [hasContent, setHasContent] = useState(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      if (adRef.current && adRef.current.children.length === 0) {
        const ins = document.createElement('ins');
        ins.className = 'adsbygoogle';
        ins.style.display = 'block';
        ins.setAttribute('data-ad-client', AD_CLIENT);
        if (adSlot) ins.setAttribute('data-ad-slot', adSlot);
        ins.setAttribute('data-ad-format', format);
        ins.setAttribute('data-full-width-responsive', 'true');
        adRef.current.appendChild(ins);
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;

        // Detect whether AdSense actually delivered an ad. AdSense sets
        // data-ad-status="filled" when an ad is shown, "unfilled" otherwise.
        // We rely strictly on this attribute — checking iframe height isn't
        // reliable because the empty placeholder still reserves ~50px.
        const checkLoaded = () => {
          const status = ins.getAttribute('data-ad-status');
          setHasContent(status === 'filled');
        };
        setTimeout(checkLoaded, 1500);
        setTimeout(checkLoaded, 3500);
        setTimeout(checkLoaded, 6000);
      }
    } catch (e) {
      console.warn('AdBanner load error:', e);
      setHasContent(false);
    }
  }, [adSlot, format]);

  return (
    <div
      ref={adRef}
      className={`w-full overflow-hidden ${className}`}
      style={{ minHeight: hasContent ? '50px' : 0, height: hasContent ? 'auto' : 0 }}
      data-testid="ad-banner"
      aria-hidden={!hasContent}
    />
  );
};

export default AdBanner;
